import {
	CAMPAIGN_SAVED,
	CLOSE_SNACKBAR,
	SETTINGS_SAVED,
	OPEN_SNACKBAR
} from "../constants"

const initialState = {
	open: false,
	message: '',
	autoHide: 4000
};

export const SnackbarReducer = (state = initialState, action) => {
	switch (action.type) {
		case CAMPAIGN_SAVED :
			state = {
				...state,
				open: true,
				message: action.payload.message
			};
			break;
		case SETTINGS_SAVED :
			state = {
				...state,
				open: true,
				message: action.payload.message
			};
			break;
		case CLOSE_SNACKBAR :
			state = initialState;
			break;
		case OPEN_SNACKBAR :
			state = {
				...state,
				message: action.payload.message,
				open: true
			};
			break;
		default:
			return state;
	}

	return state;
}


// WEBPACK FOOTER //
// ./src/reducers/snackbar.js